import ProfileTabs from "features/profile/blocks/ProfileTabs";
import React from "react";

import PageLayout from "../../common/PageLayout";

const ProfilePage: React.FC = () => (
  <PageLayout>
    <ProfileTabs />
  </PageLayout>
);

export default ProfilePage;
